var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.711,
    height: 18.484,
    viewBox: "0 0 20.711 18.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M20.163.548A1.866,1.866,0,0,0,18.841,0H1.87A1.872,1.872,0,0,0,0,1.87V16.617a1.872,1.872,0,0,0,1.87,1.867H18.841a1.872,1.872,0,0,0,1.87-1.867V1.87A1.873,1.873,0,0,0,20.163.548M1.6,1.605A.381.381,0,0,1,1.87,1.5H18.841a.371.371,0,0,1,.373.373V15.432l-4.547-4.745-.04-.04a.717.717,0,0,0-.938-.048l-.042.037-1.687,1.433L8.2,8.075a.741.741,0,0,0-.572-.236.755.755,0,0,0-.553.275L1.5,15.008V1.87A.381.381,0,0,1,1.6,1.605m.213,15.381L7.7,9.72l3.663,3.888a.773.773,0,0,0,1.025.058l1.692-1.438,4.565,4.762H1.87a.366.366,0,0,1-.052,0",
    transform: "translate(0 0)",
    fill: "#7b8085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M350.746,81.613a2.383,2.383,0,1,0-1.687-.7,2.389,2.389,0,0,0,1.687.7m-.628-3.017a.889.889,0,1,1-.262.63.891.891,0,0,1,.262-.63",
    transform: "translate(-335.851 -74.08)",
    fill: "#7b8085"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.447f9ff1.svg";
export { ForwardRef as ReactComponent };